import { useMemo } from 'react';
import type { FilterLineType } from '../../../../components/new-design/vyTableFilter';
import { useRecurringRevenueReport } from '../../../../hooks/requests/use-recurring-revenue-report';
import { useRecurringRevenueAggregations } from '../../recurring-revenue-report-page/hooks/use-recurring-revenue-aggregations';
import { filterMonthKeysByDateRange } from '../../recurring-revenue-report-page/utils/chart-movements';
import { buildRetentionRows, type RetentionRow } from '../utils/build-retention-rows';

type UseNrrGrrReportDataResult = {
  rows: RetentionRow[];
  isLoading: boolean;
  creationDate: Date;
};

export function useNrrGrrReportData(
  fromDate: Date | null,
  toDate: Date | null,
  filters: FilterLineType[],
): UseNrrGrrReportDataResult {
  const { data: recurringRevenueReportData, isLoading } = useRecurringRevenueReport();
  const { report, creationDate } = recurringRevenueReportData;

  const { bundle } = useRecurringRevenueAggregations({ report, filters });

  const rows = useMemo(() => {
    if (!bundle) return [];

    const allRows = buildRetentionRows(bundle.monthlyMovements, bundle.retentionPoints);

    if (!fromDate && !toDate) return allRows;

    const visibleMonthKeys = new Set(
      filterMonthKeysByDateRange(bundle.allMonthKeys, fromDate, toDate),
    );
    return allRows.filter((row) => visibleMonthKeys.has(row.id));
  }, [bundle, fromDate, toDate]);

  return { rows, isLoading: isLoading || bundle === null, creationDate };
}
